import Component from "@ember/component";

export default class Text extends Component {}
